/** Pulse Command — paleta global ⌘K / Ctrl+K */

export const PULSE_CMD_OPEN_WA_KEY = 'crm_pulse_open_wa_altas';
export const PULSE_CMD_WA_SEARCH_KEY = 'crm_pulse_wa_search';
export const PULSE_CMD_FOCUS_PEDIDO_KEY = 'crm_pulse_focus_pedido_id';
export const PULSE_CMD_CONV_UNREAD_KEY = 'crm_pulse_conv_unread_only';

export const PULSE_COMMAND_TOGGLE_KEY = 'k';

export const PULSE_COMMAND_GROUPS = {
  action: 'Acciones',
  contact: 'Contactos',
  conversation: 'Conversaciones',
  pedido: 'Pedidos',
  wa: 'Altas WhatsApp',
  nav: 'Módulos'
};

export const PULSE_COMMAND_QUICK_ACTIONS = [
  {
    id: 'unread-conversations',
    intent: /^(conv|conversaciones?)\s*(sin\s*leer|no\s*le[ií]d)/i,
    label: 'Conversaciones sin leer',
    description: 'Bandeja con chats pendientes de lectura',
    icon: '💬',
    group: 'action',
    permission: 'ver_conversaciones',
    allowAdmin: true,
    unreadOnly: true
  },
  {
    id: 'wa-altas',
    intent: /^(alta|altas)\s*(wa|whatsapp)|wa\s*sin\s*v[ií]nculo|whatsapp\s*sin\s*v[ií]nculo/i,
    label: 'Altas WhatsApp sin vínculo',
    description: 'Registros digitales pendientes de asociar al sanatorio',
    icon: '📱',
    group: 'action',
    permission: 'ver_contactos',
    openWa: true
  }
];
